module.exports = __webpack_public_path__ + "static/media/no-user-thumb.26530048.svg";